module.exports = "/virtual-football-league/img/amblems/right/Spain/Fake_Valencia.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Spain/Fake_Valencia.png
// module id = 2152
// module chunks = 4